/**
 * Generates null value.
 *
 * @returns {null}
 */
function nullGenerator() {
  return null;
}

export default nullGenerator;
